import React, { useState, useEffect } from "react";
import smsgatewayService from "../../../../../services/smsgateway.service";
import {useParams} from 'react-router-dom';
import {toast} from 'react-toastify'
function SmsgatewayTab() {
    
    const [loading, setLoading] = useState(true);
    const [tokens, setTokens] = useState([]);
    const {clinicId} = useParams();
    const [displayBlockingConfirmation,setBlockingConfirmation] = useState([])
    const [inputValue,setInputValue] = useState('');

    useEffect(() => {
       getTokenList();
    }, [clinicId]);

    const getTokenList = ()=>{
        setLoading(true);
    
        smsgatewayService.getTokenList(clinicId)
            .then(tokens => {
                tokens.data.forEach((item)=>{
                    item.displayBlockingConfirmation = false;
                })
                setTokens(tokens.data);
                setLoading(false);
            })
            .catch(err => {
                setLoading(false);
            });
    }
    const downloadToken = (tokenId)=>{
        console.log("download token",tokenId);
        smsgatewayService.downloadToken(clinicId,tokenId)
            .then(res => {
                 // Handle form-data header content if needed
                const contentDisposition = res.headers['content-disposition'];
                let filename = `SMS-Gateway-Token-${tokenId}.pdf`;

                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="(.+?)"/);
                    if (match && match[1]) {
                        filename = match[1];
                    }
                }
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch(err => {
                toast.error("Error while downloading token.",{
                    position:toast.POSITION.BOTTOM_RIGHT
                })
            });
    }
    const blockToken = (clinicId, tokenId)=>{
        smsgatewayService.blockToken(clinicId, tokenId)
            .then(res => {
                getTokenList();
                toast.success("Token blocked successfully.",{
                    position:toast.POSITION.BOTTOM_RIGHT
                })
            })
            .catch(err => {
                toast.error("Error while blocking token.",{
                    position:toast.POSITION.BOTTOM_RIGHT
                })
            });
    }
    const confirmBlocking = (tokenid)=>{
        console.log("confirm blocking", tokenid);
        setTokens((prevTokens) => 
            prevTokens.map((token) => 
                token.id === tokenid 
                    ? { ...token, displayBlockingConfirmation: true } 
                    : token
            )
        );
    }
    const unblockToken = (clinicId, tokenId)=>{
        smsgatewayService.unblockToken(clinicId, tokenId)
            .then(res => {
                getTokenList();
                toast.success("Token unblocked successfully.",{
                    position:toast.POSITION.BOTTOM_RIGHT
                })
            })
            .catch(err => {
                toast.error("Error while unblocking token.",{
                    position:toast.POSITION.BOTTOM_RIGHT
                })
            });
    }
    const createToken = ()=>{
        smsgatewayService.createToken(clinicId)
            .then(res => {
                getTokenList();
            })
            .catch(err => {
                toast.error("Error while creating token.",{
                    position:toast.POSITION.BOTTOM_RIGHT
                })
            });
    }
  const readableDate = (date)=>{
    const d = new Date(date);
    return d.toLocaleString();
  }
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
};
  return (
    <>
      <div className="d-flex justify-content-between">
        <h5 className="card-title" style={{ color: "#012970" }}>
          {" "}
          Sms Gateway
        </h5>
        <div>
          <button
            className="btn btn-secondary btn-sm mt-2"
            onClick={createToken}
          >
            <i className="bi bi-key"></i> Create New Token
          </button>
        </div>
      </div>
      <div className="table-responsive">
        <table className="table table-striped table-hover table-bordered">
          <thead>
            <tr>
              <th scope="col">Token</th>
              <th scope="col">Role</th>
              <th scope="col">Created At</th>
              <th scope="col">Status</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr>
                <td colSpan="5" className="text-center">
                  <div className="loader"></div>
                </td>
              </tr>
            )}
            {tokens.map((token, index) => (
              <tr key={index}>
                <td>{token.username}</td>
                <td>{token.role}</td>
                <td>{readableDate(token.createdAt)}</td>
                <td>{token.isActive?"Active":"Inactive"}</td>
                <td>
                  <div className="d-flex flex-column">
                    <div>
                            <button className="btn btn-secondary btn-sm" onClick={()=>downloadToken(token.id)}>
                            <i className="bi bi-download"></i> Download
                        </button>
                        {token.isBlocked? 
                            <button className="btn btn-secondary btn-sm ms-2" onClick={()=>unblockToken(clinicId, token.id)}>
                            <i className="bi bi-unlock"></i> Unblock
                        </button>:
                        <button className="btn btn-danger btn-sm ms-2" onClick={()=>confirmBlocking(token.id)}>
                            <i className="bi bi-lock"></i> Block
                        </button>}
                    </div>
                    <div>
                        {token.displayBlockingConfirmation &&
                            <div className="form-group border m-2 rounded p-2">
                                <label className="form-label text-muted mt-1" htmlFor="exampleFormControlTextarea1">Enter "block token" below</label>
                                <input type="text"
                                     className="form-control" 
                                     placeholder="Enter here to block"
                                     value={inputValue}
                                     onChange={handleInputChange}
                                     />
                                <div className="d-flex justify-content-between">
                                    <button 
                                        className="btn btn-danger btn-sm mt-2"  
                                        onClick={()=>blockToken(clinicId, token.id)}
                                        disabled={inputValue !== 'block token'}
                                        >
                                        <i className="bi bi-lock"></i> Block
                                    </button>
                                    <button className="btn btn-secondary btn-sm mt-2" onClick={getTokenList}>
                                        <i className="bi bi-unlock"></i> Cancel
                                    </button>
                                </div>

                            </div>}
                       
                    </div>
                  </div>
                </td>
              </tr>
            ))}
            
          </tbody>
        </table>
      </div>
    </>
  );
}

export default SmsgatewayTab;
